// One place that decides what goes in the browser tab.
//
// The convention is trail-then-brand, most specific first:
//
//   pageTitle('Events')                 => "Events | Timelydo"
//   pageTitle('Bookings', 'Analytics')  => "Bookings | Analytics | Timelydo"
//
// Route definitions carry only the trail (`meta.title`), never the brand, so
// the suffix is applied once here instead of being repeated across every route
// and every component that sets a title of its own.

const FALLBACK_NAME = 'Timelydo'

// Read at call time rather than at module load: `window.APPLICATION_NAME` is
// written by the Rails layout, and on a Turbo navigation this module is
// evaluated before that script has necessarily run again.
export function appName() {
  return window.APPLICATION_NAME || FALLBACK_NAME
}

export function pageTitle(...parts) {
  const trail = parts.filter(Boolean)
  return trail.length ? `${trail.join(' | ')} | ${appName()}` : appName()
}
